import { JsonResultClass } from "./httpManager";
import toastr from "toastr";
import 'toastr/build/toastr.min.css';

export class NotificationHelper {
    private static _defaults: ToastrOptions = {
        timeOut: 3000,
        closeButton: true,
        positionClass: "toast-top-center",
        closeHtml: `<i class='fal fa-times'></i>`,
        preventDuplicates: true
    };
    private static _formatMessage = (msg: string, type: ToastType) => {
        let icon = "";
        switch (type) {
            case ToastType.Success:
                icon = "<i style='font-size:24px;align-self:center' class='fal fa-check-circle'></i>";
                break;
            case ToastType.Error:
                icon = "<i style='font-size:24px;align-self:center' class='fal fa-ban'></i>";
                break;
            case ToastType.Info:
                icon = "<i style='font-size:24px;align-self:center' class='fal fa-info-circle'></i>";
                break;
            case ToastType.Warning:
                icon = "<i style='font-size:24px;align-self:center' class='fal fa-exclamation-triangle'></i>";
                break;
            default: break;
        }

        return `<div class='toast-wrapper'>${icon}<div style ="flex:1;margin-left:5px" class='toast-wrapper__message'>${msg}</div></div>`;
    }


    public static showSuccessMessage(message: string, options?: ToastrOptions) {
        return toastr.success(this._formatMessage(message, ToastType.Success), null, options ? $.extend({}, this._defaults, options) : this._defaults);
    }

    public static showErrorMessage(message: string, options?: ToastrOptions) {
        const opts = $.extend({}, this._defaults, { timeOut: 5000 });
        return toastr.error(this._formatMessage(message, ToastType.Error), null, options ? $.extend({}, opts, options) : opts);
    }

    public static showWarningMessage(message: string, options?: ToastrOptions) {
        return toastr.warning(this._formatMessage(message, ToastType.Warning), null, options ? $.extend({}, this._defaults, options) : this._defaults);
    }

    public static showInfoMessage(message: string, options?: ToastrOptions) {
        return toastr.info(this._formatMessage(message, ToastType.Info), null, options ? $.extend({}, this._defaults, options) : this._defaults);
    }

    public static showErrorResult(result: JsonResultClass, options?: ToastrOptions) {
        const opts = $.extend({}, this._defaults, { timeOut: 5000 });
        let message = result.Message;
        if (result.AdditionalData?.readPermissionDeniedReasons) {
            for (let deniedReason of result.AdditionalData.readPermissionDeniedReasons)
                message += "</br></br>" + deniedReason.Reason;
        }
        return toastr.error(this._formatMessage(message, ToastType.Error), null, options ? $.extend({}, opts, options) : opts);
    }

    public static clearMessages() {
        toastr.remove();
    }
}

enum ToastType {
    Success, Error, Info, Warning
}